<template>
  <div>
    <AddNewOrderFormReferenceArea
      :settingsOrderShowLinkedOrderNumberField="settingsOrderShowLinkedOrderNumberField"
      :isOceanExport="isOceanExport"
      :isOceanImport="isOceanImport"
      :isLand="isLandOrder"
      :orderData="orderData"
      :showBrokerFields="showBrokerFields"
      :mappedBLs="mappedBLs"
      :isRailPickUp="isRailPickUp"
      :isRailDropOff="isRailDropOff"
      :activeBLs="activeBLs"
    >
    </AddNewOrderFormReferenceArea>
    <div class="uk-card-small uk-card-default uk-margin-small-top">
      <div class="uk-card-body">
        <div class="uk-grid uk-grid-divider">
          <div
            class="uk-width-1-3"
            v-if="!isAddingNewDropoff & !isAddingNewBillTo"
          >
            <template v-if="isLandOrder">
              <p class="uk-margin-remove-bottom">
                Pick-Up Location (*required)
              </p>
              <div class="uk-margin uk-flex-inline uk-child-width-auto uk-grid">
                <FilterSelector
                  v-if="terminals"
                  :preserve-search="true"
                  :showLabels="false"
                  placeholder="Location"
                  v-model="orderData.pickUpLocation"
                  :customLabel="(x) => (x.shortName ? x.shortName : x.name)"
                  :options="receivingCustomers"
                  class="uk-width-medium"
                  @search-change="onReceivingCustomerSearch"
                ></FilterSelector>
                <div
                  v-if="
                    orderData.pickUpLocation &&
                    orderData.pickUpLocation.deliveryAddress
                  "
                >
                  <p class="uk-margin-remove-bottom uk-margin-small-top">
                    {{ orderData.pickUpLocation.deliveryAddress.streetAddress }}
                  </p>
                  <p class="uk-margin-remove-top">
                    {{ addressLine3(orderData.pickUpLocation.deliveryAddress) }}
                  </p>
                </div>
              </div>
            </template>
            <template v-else>
              <p v-if="isOceanExport" class="uk-margin-remove-bottom">
                Drop-Off Terminal (*required)
              </p>
              <p v-else class="uk-margin-remove-bottom">
                Pick-Up Terminal (*required)
              </p>
              <div class="uk-margin uk-flex-inline uk-child-width-auto uk-grid">
                <FilterSelector
                  v-if="terminals"
                  :showLabels="false"
                  placeholder="Terminal"
                  v-model="orderData.pickUpLocation"
                  :customLabel="(x) => (x.shortName ? x.shortName : x.name)"
                  :options="terminals"
                  class="uk-width-medium"
                ></FilterSelector>
              </div>
            </template>
          </div>
          <div
            v-if="!isAddingNewBillTo"
            :class="{
              'uk-width-1-3': !isAddingNewDropoff,
              'uk-width-1-1': isAddingNewDropoff,
            }"
          >
            <p v-if="isOceanExport">Pick-up location</p>
            <p v-else>Drop-Off Location (*required)</p>
            <div
              v-if="
                !orderData.dropOffLocation &&
                receivingCustomers &&
                receivingCustomers.length == 0 &&
                !isAddingNewDropoff
              "
            >
              <Button
                @click="createReceiver"
                v-if="receivingCustomerQuery.length > 0"
                class="uk-margin-small-bottom"
              >
                Create receiver {{ receivingCustomerQuery }}
              </Button>
            </div>
            <FilterSelector
              v-if="receivingCustomers && !isAddingNewDropoff"
              :preserve-search="true"
              :showLabels="false"
              placeholder="Terminal"
              v-model="orderData.dropOffLocation"
              :customLabel="(x) => (x.displayName ? x.displayName : x.name)"
              :options="receivingCustomers"
              class="uk-width-medium"
              @search-change="onReceivingCustomerSearch"
            >
              <template v-slot:noResult class="uk-background-muted">
                <p>No receiver found, please consider creating one</p>
              </template>
            </FilterSelector>

            <div class="uk-grid uk-margin-remove-top" v-if="isAddingNewDropoff">
              <InputField
                id="streetAddReceiving"
                label="Street Address"
                class="uk-width-2-3"
                v-model="newDropoff.streetAddress"
              ></InputField>
              <InputField
                class="uk-width-1-3"
                id="suitNumberReceiving"
                label="Suite #"
                v-model="newDropoff.suite"
              ></InputField>
            </div>
            <div
              v-else-if="
                orderData.dropOffLocation &&
                orderData.dropOffLocation.deliveryAddress
              "
            >
              <p class="uk-margin-remove-bottom uk-margin-small-top">
                {{ orderData.dropOffLocation.deliveryAddress.streetAddress }}
              </p>
              <p class="uk-margin-remove-top">
                {{ addressLine3(orderData.dropOffLocation.deliveryAddress) }}
              </p>
            </div>
            <div class="uk-grid uk-margin-remove-top" v-if="isAddingNewDropoff">
              <InputField
                class="uk-width-1-3"
                id="cityReceiving"
                label="City"
                v-model="newDropoff.city"
              ></InputField>
              <InputField
                class="uk-width-1-3"
                id="stateReceiving"
                label="State"
                v-model="newDropoff.state"
              ></InputField>
              <InputField
                class="uk-width-1-3"
                id="zipReceiving"
                label="Zip"
                v-model="newDropoff.zipCode"
              ></InputField>
            </div>
            <div class="uk-grid uk-margin-remove-top" v-if="isAddingNewDropoff">
              <InputField
                class="uk-width-1-3"
                id="contactEmail"
                label="Email"
                v-model="newContact.email"
              ></InputField>
              <InputField
                class="uk-width-1-3"
                id="Name"
                label="Name"
                v-model="newContact.name"
              ></InputField>
              <InputField
                class="uk-width-1-3"
                id="zipReceiving"
                label="Phone Number"
                v-model="newContact.phoneNumber"
              ></InputField>
            </div>
            <div v-if="isAddingNewDropoff" class="uk-flex">
              <Button
                @click="confirmReceiverAddition"
                class="uk-width-3-5 uk-margin-small-top"
              >
                Save receiver {{ receivingCustomerQuery }}
              </Button>
              <Button
                :isGray="true"
                @click="cancelReceiverCreate"
                class="uk-margin-small-left uk-margin-small-top uk-width-2-5"
              >
                Cancel
              </Button>
            </div>
          </div>
          <div
            :class="{
              'uk-width-1-3': !isAddingNewBillTo,
              'uk-width-1-1': isAddingNewBillTo,
            }"
            v-if="!isAddingNewDropoff"
          >
            <p>Bill To (*required)</p>
            <div
              v-if="
                !orderData.billTo &&
                billingCustomers &&
                billingCustomers.length == 0 &&
                !isAddingNewBillTo
              "
            >
              <Button
                @click="createBillTo"
                v-if="billingCustomerQuery.length > 0"
                class="uk-margin-small-bottom"
              >
                Create customer {{ billingCustomerQuery }}
              </Button>
            </div>
            <FilterSelector
              :preserve-search="true"
              v-if="billingCustomers && !isAddingNewBillTo"
              :showLabels="false"
              placeholder="Billng Customer"
              v-model="orderData.billTo"
              :customLabel="(x) => (x.displayName ? x.displayName : x.name)"
              :options="billingCustomers"
              class="uk-width-medium"
              @search-change="onBillingCustomerSearch"
            ></FilterSelector>
            <div class="uk-grid uk-margin-remove-top" v-if="isAddingNewBillTo">
              <InputField
                class="uk-width-2-3"
                id="streetAddBillTo"
                label="Street Address"
                v-model="newBillTo.streetAddress"
              ></InputField>
              <InputField
                class="uk-width-1-3"
                id="suitNumber"
                label="Suite #"
                v-model="newBillTo.suite"
              ></InputField>
            </div>
            <div
              v-else-if="orderData.billTo && orderData.billTo.billingAddress"
            >
              <p class="uk-margin-remove-bottom uk-margin-small-top">
                {{ orderData.billTo.billingAddress.streetAddress }}
              </p>
              <p class="uk-margin-remove-top">
                {{ addressLine3(orderData.billTo.billingAddress) }}
              </p>
            </div>
            <div class="uk-grid uk-margin-remove-top" v-if="isAddingNewBillTo">
              <InputField
                class="uk-width-1-3"
                id="city"
                label="City"
                v-model="newBillTo.city"
              ></InputField>
              <InputField
                class="uk-width-1-3"
                id="state"
                label="State"
                v-model="newBillTo.state"
              ></InputField>
              <InputField
                class="uk-width-1-3"
                id="zip"
                label="Zip"
                v-model="newBillTo.zipCode"
              ></InputField>
            </div>
            <div class="uk-grid uk-margin-remove-top" v-if="isAddingNewBillTo">
              <InputField
                class="uk-width-1-3"
                id="contactEmail"
                label="Email"
                v-model="newContact.email"
              ></InputField>
              <InputField
                class="uk-width-1-3"
                id="Name"
                label="Name"
                v-model="newContact.name"
              ></InputField>
              <InputField
                class="uk-width-1-3"
                id="zipReceiving"
                label="Phone Number"
                v-model="newContact.phoneNumber"
              ></InputField>
            </div>
            <div v-if="isAddingNewBillTo" class="uk-flex">
              <Button
                @click="confirmBillToAddition"
                class="uk-width-3-5 uk-margin-small-top"
              >
                Save customer {{ billingCustomerQuery }}
              </Button>
              <Button
                :isGray="true"
                @click="cancelBillToCreate"
                class="uk-margin-small-left uk-margin-small-top uk-width-2-5"
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="uk-card-small uk-card-default uk-margin-small-top"
      v-if="settingsOrderShowEmergencyInformation"
    >
      <div class="uk-card-body">
        <div class="uk-grid uk-grid-divider">
          <div class="uk-width-1-3">
            <div class="uk-margin uk-flex-inline uk-child-width-auto uk-grid">
              <InputField
                class=""
                id="orderCarrierName"
                label="Carrier Name"
                v-model="orderData.carrierName"
              ></InputField>
            </div>
          </div>
          <div class="uk-width-1-3">
            <div class="uk-margin uk-flex-inline uk-child-width-auto uk-grid">
              <InputField
                class=""
                id="scacCode"
                label="SCAC"
                v-model="orderData.scacCode"
              ></InputField>
            </div>
          </div>
          <div class="uk-width-1-3">
            <div class="uk-margin uk-flex-inline uk-child-width-auto uk-grid">
              <InputField
                class=""
                id="EmergencyPhoneNumber"
                label="Emergency Response Phone Number"
                v-model="orderData.emergencyResponsePhoneNumber"
              ></InputField>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="uk-card-small uk-card-default uk-margin-small-top"
      v-if="shouldShowShipLineInfo"
    >
      <ship-line-card
        :showBrokerFields="showBrokerFields"
        :orderData="orderData"
      >
      </ship-line-card>
    </div>
    <AddContainersArea
      v-if="!isLandOrder"
      :activeContainersWithoutOrder="activeContainersWithoutOrder"
      :orderData="orderData"
      :isOceanExport="isOceanExport"
      :isOceanImport="isOceanImport"
      :isLand="isLandOrder"
      :isRailPickUp="isRailPickUp"
      :isRailDropOff="isRailDropOff"
      :settingsOrderLtlEnabled="settingsOrderLtlEnabled"
    ></AddContainersArea>
    <AddLoadsArea v-else :orderData="orderData"> </AddLoadsArea>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import TerminalsQuery from '@/gql/terminals/Terminals.gql';
import CreateCustomerMutation from '@/gql/customers/CreateCustomer.gql';

import Button from '@/components/core/Button.vue';
import { CONTAINER_TYPES, ORDER_TYPE } from '../../../types';

import { SteamShipLinesMap, SteamShipLines } from '../../../utils/constants';

import AddContainersArea from './AddContainersArea.vue';

import AddLoadsArea from './AddLoadsArea.vue';
import InputField from '../../core/Input/InputField.vue';

import { addressMixin } from '../../../utils/address';
import { dateFormatMixin } from '../../../utils/date';
import { orderTypeMixin } from '../../../utils/order';

import FilterSelector from '../../core/FilterSelector.vue';
import AddNewOrderFormReferenceArea from './AddNewOrderFormReferenceArea.vue';
import ShipLineCard from './ShipLineCard.vue';

export default defineComponent({
  props: {
    orderType: String,
    orderData: Object,
    billingCustomers: Array,
    receivingCustomers: Array,
    activeBLs: Array,
    activeContainersWithoutOrder: Array,
    settingsOrderShowLinkedOrderNumberField: Boolean,
    showVesselInformation: Boolean,
    settingsOrderShowEmergencyInformation: Boolean,
    settingsOrderLtlEnabled: Boolean,
    showBrokerFields: Boolean,
  },
  mixins: [addressMixin, dateFormatMixin, orderTypeMixin],
  components: {
    InputField,

    AddContainersArea,
    FilterSelector,
    Button,
    AddLoadsArea,
    AddNewOrderFormReferenceArea,
    ShipLineCard,
  },
  computed: {
    mappedBLs(): any[] {
      const vm = (this as any);

      if (!vm.activeBLs) {
        return [];
      }
      return vm.activeBLs.map((x) => `${x.billOfLadingId}`);
    },
    shouldShowShipLineInfo(): boolean {
      const vm = (this as any);

      return (
        (vm.isOceanOrder ||
          (vm.isLandOrder && vm.showBrokerFields)) &&
        vm.showVesselInformation
      );
    },
  },
  data() {
    return {
      isAddingNewDropoff: false,
      isAddingNewBillTo: false,
      CONTAINER_TYPES,
      receivingCustomerQuery: '',
      billingCustomerQuery: '',
      newDropoff: {
        suite: null,
        streetAddress: null,
        city: null,
        state: null,
        zipCode: null,
      },
      newContact: {
        name: null,
        phoneNumber: null,
        email: null,
      },
      newBillTo: {
        suite: null,
        streetAddress: null,
        city: null,
        state: null,
        zipCode: null,
      },
    };
  },
  methods: {
    confirmReceiverAddition() {
      const vm = (this as any);

      vm.$apollo
        .mutate({
          mutation: CreateCustomerMutation,
          variables: {
            module: 'CONTRAK',
            name: vm.receivingCustomerQuery,
            receiverAddress: vm.newDropoff,
            contact: vm.newContact,
          },
        })
        .then((result) => {
          vm.newDropoff = {
            suite: null,
            streetAddress: null,
            city: null,
            state: null,
            zipCode: null,
          };
          vm.newContact = {
            name: null,
            phoneNumber: null,
            email: null,
          };
          vm.isAddingNewDropoff = false;
          vm.orderData.dropOffLocation = result.data.createCustomer.customer;
        });
    },
    confirmBillToAddition() {
      const vm = (this as any);

      vm.$apollo
        .mutate({
          mutation: CreateCustomerMutation,
          variables: {
            module: 'CONTRAK',
            name: vm.billingCustomerQuery,
            billingAddress: vm.newBillTo,
            contact: vm.newContact,
          },
        })
        .then((result) => {
          vm.newBillTo = {
            suite: null,
            streetAddress: null,
            city: null,
            state: null,
            zipCode: null,
          };
          vm.newContact = {
            name: null,
            phoneNumber: null,
            email: null,
          };
            (vm.isAddingNewBillTo = false);
          vm.orderData.billTo = result.data.createCustomer.customer;
        });
    },
    changedETA(dateStr: string) {
      const vm = (this as any);

      const parsedDate = vm.formatDate(dateStr);
      vm.orderData.shipLineInfo.eta = parsedDate;
    },
    onReceivingCustomerSearch(customerName: string) {
      const vm = (this as any);

      vm.receivingCustomerQuery = customerName;
      vm.$emit('onReceivingCustomerSearch', customerName);
    },
    onBillingCustomerSearch(customerName: string) {
      const vm = (this as any);

      vm.billingCustomerQuery = customerName;
      vm.$emit('onBillingCustomerSearch', customerName);
    },
    createReceiver() {
      (this as any).isAddingNewDropoff = true;
    },
    cancelReceiverCreate() {
      (this as any).isAddingNewDropoff = false;
    },
    createBillTo() {
      (this as any).isAddingNewBillTo = true;
    },
    cancelBillToCreate() {
      (this as any).isAddingNewBillTo = false;
    },
  },
  ...{
    apollo: {
      terminals: {
        query: TerminalsQuery,
      },
    },
  },
} as any);
</script>
